import React from 'react';
import SearchParams from '../Elements/SearchParams';
import ServiceSearchParams from '../Contents/Sales/ServiceAdmin/ServiceSearchParams';
import AuthService from './authService.js';
import ServiceListItem from '../Domain/ServiceListItem.js';

export default class ServiceItemService extends React.Component {
  static GetServiceItemList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, ServiceSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/Service/GetAllServiceAsync?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetServiceBySelection(item) {
    const url = `/api/Service/GetSelectedServiceByIdAsync/${item.ServiceId}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetServiceItemById(id) {
    const url = `/api/Service/GetServiceByIdAsync/${id}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new ServiceListItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static Remove(Id) {
    const url = `/api/Service/RemoveService/${Id}`;
    return AuthService.getInstance().CallBackendFunctionDelete(url);
  }

  static EditService(item) {
    const url = '/api/Service/PostServiceAsync';
    const string = this.toString(item);
    const json = JSON.stringify(string);
    return AuthService.getInstance().CallBackendFunctionPost(url, json);
  }

  static toString(o) {
    Object.keys(o).forEach((k) => {
      // Leave null/undefined as-is — coercing them to the strings "null"/"undefined"
      // breaks backend deserialization of array fields (e.g. "undefined" -> string[]).
      if (o[k] === null || o[k] === undefined) {
        return;
      }
      // Arrays and nested objects are passed through unchanged.
      if (typeof o[k] === 'object') {
        return;
      }
      o[k] = `${o[k]}`;
    });
    return o;
  }

  static UpdateCommissionRate(item) {
    const url = `/api/Service/UpdateConnectedCommissionRateAsync`;
    const commissionRateJson = JSON.stringify(item);
    return AuthService.getInstance().CallBackendFunctionPut(url, commissionRateJson);
  }
}
